/* ==========================================================================
   Spotlight autoplay + designer cluster click-to-play
   Ships as: assets/event-video.js  (loaded with defer)

   Two different clip behaviors share this file:

   - Spotlight rail [data-autoplay-clip]: always muted, plays automatically
     while at least half on screen, pauses when scrolled out. No button, no
     sound — a silent lookbook rail. Respects prefers-reduced-motion.

   - Designer cluster [data-clip]: click-to-play, poster + play button, one
     clip plays at a time, muted until the corner button is used.

   Preload is "metadata", not "none", on both — enough to grab the first
   frame as a free thumbnail for clips with no poster image set, without
   downloading the whole file. Some browsers (Firefox in particular) load
   the metadata but don't paint frame 0 on their own, so this nudges
   currentTime forward a hair to force it to render.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function primeFirstFrame(video) {
    if (video.hasAttribute('poster')) return;
    video.addEventListener('loadedmetadata', function () {
      if (video.currentTime === 0) video.currentTime = 0.01;
    });
  }

  /* ---- spotlight: autoplay on scroll, always muted, no controls -------- */

  var autoplayWraps = Array.prototype.slice.call(document.querySelectorAll('[data-autoplay-clip]'));
  if (autoplayWraps.length) {
    var autoplayVideos = autoplayWraps.map(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video) return null;
      video.muted = true;
      video.controls = false;
      primeFirstFrame(video);
      return video;
    }).filter(Boolean);

    if (reduceMotion || !('IntersectionObserver' in window)) {
      // motion-sensitive visitors get a static poster frame, no playback
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.5 });
      autoplayVideos.forEach(function (v) { io.observe(v); });
    }
  }

  /* ---- designer cluster: click-to-play ---------------------------------- */

  var clips = Array.prototype.slice.call(document.querySelectorAll('[data-clip]'));
  if (!clips.length) return;

  var players = [];

  clips.forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('[data-clip-play]');
    var muteBtn = wrap.querySelector('[data-clip-mute]');
    if (!video || !playBtn) return;

    video.muted = true;
    video.controls = false;
    primeFirstFrame(video);

    function play() {
      players.forEach(function (other) {
        if (other.video !== video && !other.video.paused) other.video.pause();
      });
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    playBtn.addEventListener('click', function () {
      if (video.paused) play(); else video.pause();
    });

    video.addEventListener('click', function () {
      if (video.paused) play(); else video.pause();
    });

    video.addEventListener('play', function () { wrap.setAttribute('data-playing', ''); });
    video.addEventListener('pause', function () { wrap.removeAttribute('data-playing'); });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        muteBtn.setAttribute('aria-pressed', String(!video.muted));
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
      video.addEventListener('play', function () { muteBtn.hidden = false; });
    }

    players.push({ video: video });
  });
})();
